export default __webpack_public_path__ + "static/media/Datenschutzerklaerung_Blogs_Homepages_ohne_Bestellfunktion-nicht_Shops-2021.47a9b452.pdf";